import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import ListeningStatus from "Components/Global/ListeningStatus";
import { listen } from "Services/Listen";
import { COPY_STRINGS } from "Constants/translatedCopy";
import { interventionType } from "Constants/interventionSelectionConstants";
import riddleIcon from "./riddle-icon.jpg";

import "./Riddle.scss";

export default class Riddle extends React.Component {
  isMounted = true;

  constructor(props) {
    super(props);
    this.state = { showAnswer: false };
    this.speakRiddle = this.speakRiddle.bind(this);
    this.onListeningDone = this.onListeningDone.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidMount() {
    this.isMounted = true;
    this.speakRiddle();
  }

  componentWillUnmount() {
    this.isMounted = false;
  }

  speakRiddle() {
    const { word } = this.props;
    const { RIDDLE, RIDDLE_ANSWER } = this.props.wordMetadata;

    if (!(RIDDLE && RIDDLE_ANSWER)) {
      this.close();
      return;
    }

    this.props.speech.speak({
      textToSpeak: `${COPY_STRINGS.intervention_strings.heres_a_riddle}. <break time=\"0.5s\"/> ${RIDDLE}`,
      onEnd: () => {
        if (!this.isMounted) return;
        listen({
          speech: this.props.speech,
          targetWord: word,
          callback: this.onListeningDone,
          interventionType: interventionType.riddle,
        });
      },
    });
  }

  onListeningDone(result) {
    if (!this.isMounted) return;
    const matches = result.matches.targetMatches;
    const feedback =
      matches > 0
        ? COPY_STRINGS.intervention_strings.riddle_solved
        : COPY_STRINGS.intervention_strings.riddle_unsolved(
            this.props.wordMetadata.RIDDLE_ANSWER
          );

    this.setState(
      { showAnswer: true },
      this.props.speech.speak({ textToSpeak: feedback, onEnd: this.close })
    );
  }

  close() {
    if (!this.isMounted) return;

    this.props.handleMessage({
      continueWithoutSpeaking: true,
      endOfPhrase: this.props.endOfPhrase,
    });
  }

  render() {
    const { word, wordMetadata } = this.props;
    const wordClasses = cx({
      word: true,
      longWord: word ? word.length > 8 : false,
    });
    return (
      <div className="wordInterventionModal">
        <div className="left">
          <div className="icon">
            <img className="interventionIcon" src={riddleIcon} alt="" />
          </div>
        </div>
        <div className="right">
          <div className={wordClasses}>
            <span>
              {this.state.showAnswer ? wordMetadata.RIDDLE_ANSWER : "???"}
            </span>
          </div>
          <div className="listeningStatusWrapper">
            <ListeningStatus />
          </div>
        </div>
      </div>
    );
  }
}

Riddle.propTypes = {
  word: PropTypes.string,
  wordMetadata: PropTypes.object,
  endOfPhrase: PropTypes.bool,
  speech: PropTypes.object,
  handleMessage: PropTypes.func,
};
